export const spas = [
  {
    id: "1",
    name: "The Queen City Sanctuary",
    type: "Luxury Spa",
    address: "201 S College St, Charlotte, NC 28244",
    neighborhood: "Uptown",
    phone: "(704) 555-0192",
    description: "Located in the heart of Uptown Charlotte, The Queen City Sanctuary offers a luxurious escape from the bustling city. Specializing in holistic treatments, our expert therapists use organic, locally sourced products to rejuvenate your mind and body.",
    imageUrl: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?auto=format&fit=crop&q=80&w=800",
    hours: "Mon-Sat: 9am - 8pm | Sun: 10am - 6pm",
    features: ["Couples Massage", "Sauna", "Valet Parking", "Organic Products"],
    deal: {
      title: "First-Time Guest Special",
      description: "25% off any 90-minute signature massage for new clients.",
      code: "QUEEN25",
      expires: "2024-12-31",
      discountValue: "25% OFF",
      terms: "Valid for new customers only. Cannot be combined with other offers."
    },
    services: [
      { name: "Signature Swedish Massage", price: 120, duration: "60 min" },
      { name: "Deep Tissue Recovery", price: 140, duration: "60 min" },
      { name: "Hot Stone Therapy", price: 160, duration: "90 min" },
      { name: "Radiance Facial", price: 110, duration: "50 min" }
    ],
    lat: 35.2255,
    lng: -80.8415
  },
  {
    id: "2",
    name: "South End Serenity",
    type: "Massage Clinic",
    address: "1920 Camden Rd, Charlotte, NC 28203",
    neighborhood: "South End",
    phone: "(704) 555-0284",
    description: "A modern, minimalist space dedicated purely to the art of massage. South End Serenity focuses on targeted muscle relief and athletic recovery in a calming, distraction-free environment.",
    imageUrl: "https://images.unsplash.com/photo-1600334089648-b0d9d3028eb2?auto=format&fit=crop&q=80&w=800",
    hours: "Tue-Sun: 10am - 7pm | Mon: Closed",
    features: ["Sports Massage", "Cupping", "Online Booking"],
    deal: {
      title: "Athlete's Recovery Package",
      description: "Book 3 Deep Tissue sessions and get the 4th one free.",
      code: "SOUTHENDPRO",
      expires: "2025-01-15",
      discountValue: "BUY 3 GET 1",
      terms: "Must be used within 6 months of purchase."
    },
    services: [
      { name: "Targeted Deep Tissue", price: 95, duration: "60 min" },
      { name: "Sports Recovery Massage", price: 105, duration: "60 min" },
      { name: "Trigger Point Therapy", price: 55, duration: "30 min" },
      { name: "Cupping Add-on", price: 25, duration: "15 min" }
    ],
    lat: 35.2139,
    lng: -80.8549
  },
  {
    id: "3",
    name: "Lotus Blossom Day Spa",
    type: "Day Spa",
    address: "14825 Ballantyne Village Way, Charlotte, NC 28277",
    neighborhood: "Ballantyne",
    phone: "(704) 555-0371",
    description: "Your suburban oasis in Ballantyne. Lotus Blossom provides full-day retreat packages, encompassing everything from restorative massages to advanced skincare and nail services.",
    imageUrl: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&q=80&w=800",
    hours: "Mon-Sat: 9am - 7pm | Sun: Closed",
    features: ["Full Day Packages", "Nail Salon", "Showers", "Gift Cards"],
    deal: {
      title: "Weekday Wellness",
      description: "Complimentary Hot Stone add-on for any massage booked Tue-Thu.",
      code: "LOTUSWEEK",
      expires: "2024-11-30",
      discountValue: "FREE ADD-ON",
      terms: "Available Tuesday through Thursday only."
    },
    services: [
      { name: "Relaxation Massage", price: 100, duration: "60 min" },
      { name: "Prenatal Massage", price: 115, duration: "60 min" },
      { name: "Anti-Aging Facial", price: 130, duration: "60 min" },
      { name: "The Half-Day Retreat", price: 250, duration: "3 hours" }
    ],
    lat: 35.0535,
    lng: -80.8485
  },
  {
    id: "4",
    name: "NoDa Wellness Collective",
    type: "Wellness Center",
    address: "3205 N Davidson St, Charlotte, NC 28205",
    neighborhood: "NoDa",
    phone: "(704) 555-0499",
    description: "An eclectic and holistic healing arts center in Charlotte's arts district. We offer alternative therapies alongside traditional massage, including Reiki, sound baths, and reflexology.",
    imageUrl: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?auto=format&fit=crop&q=80&w=800",
    hours: "Wed-Sun: 11am - 8pm | Mon-Tue: Closed",
    features: ["Holistic Therapies", "Reiki", "Walk-ins Welcome"],
    deal: {
      title: "Arts District Special",
      description: "$20 off your first Reiki or Sound Bath session.",
      code: "NODAVIBE",
      expires: "2024-12-24",
      discountValue: "$20 OFF",
      terms: "Valid for first-time holistic service booking."
    },
    services: [
      { name: "Custom Blend Massage", price: 90, duration: "60 min" },
      { name: "Reflexology Session", price: 65, duration: "45 min" },
      { name: "Reiki Energy Healing", price: 80, duration: "60 min" },
      { name: "Sound Bowl Meditation", price: 40, duration: "45 min" }
    ],
    lat: 35.2471,
    lng: -80.8049
  },
  {
    id: "5",
    name: "Plaza Midwood Bathhouse",
    type: "Spa & Bathhouse",
    address: "1500 Central Ave, Charlotte, NC 28205",
    neighborhood: "Plaza Midwood",
    phone: "(704) 555-0522",
    description: "A modern take on traditional bathhouses. Featuring hot and cold plunge pools, steam rooms, and restorative massage therapies. A perfect communal yet relaxing experience.",
    imageUrl: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?auto=format&fit=crop&q=80&w=800",
    hours: "Everyday: 8am - 10pm",
    features: ["Cold Plunge", "Steam Room", "Communal Baths"],
    deal: {
      title: "Plunge & Massage Combo",
      description: "Free Day Pass with any booked 90-minute massage.",
      code: "PLAZACOMBO",
      expires: "2024-12-31",
      discountValue: "FREE PASS",
      terms: "Day pass must be used on same day as massage."
    },
    services: [
      { name: "Bathhouse Day Pass", price: 45, duration: "All Day" },
      { name: "Swedish Massage + Pass", price: 135, duration: "60 min" },
      { name: "CBD Muscle Relief", price: 125, duration: "60 min" }
    ],
    lat: 35.2215,
    lng: -80.8132
  }
];